module.exports = __webpack_public_path__ + "static/media/IE.a32816e1.png";